import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  emailValidator,
  MobileNoIntValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { closed } from "../../components/drawer/drawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import IconButton from "../../components/common/IconButton";
import { getAllActiveLeadSource } from "../leadsource/services/leadsource.service";
import { ILeadSource } from "../leadsource/leadsourceModel";
import { CONTACTTYPE, NAMEPREFIX } from "../../_contstants/common";
import { insertContact } from "./services/contact.services";
import { getAllContacts } from "./services/contact.services";

const CreateContact: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const formLoading = useAppSelector((state) => state.contact.formLoading);
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails
  );
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList
  );

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  useEffect(() => {
    dispatch(getAllActiveLeadSource());

    return () => {
      dispatch(closed());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      const insertPayload = {
        Initial: values?.Initial ? values?.Initial : "",
        FirstName: values?.FirstName ? values?.FirstName : "",
        LastName: values?.LastName ? values?.LastName : "",
        MobileNo: values?.MobileNo ? values?.MobileNo : "",
        CountryCode: values?.CountryCode ? values?.CountryCode : "",
        EmailID: values?.EmailID ? values?.EmailID : "",
        ContactType: values?.ContactType ? values?.ContactType : "",
        LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
      };
      const response = await dispatch(insertContact(insertPayload));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(closed());
        dispatch(
          getAllContacts({
            ...ContactFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          })
        );
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{}}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout style={{}} gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
            <GridLayoutItem className="mui-drawer-header">
              <Typography.h4 className="m-0">{"Add Contact"}</Typography.h4>
              <IconButton
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
                icon={RxCross1}
              />
            </GridLayoutItem>
            <GridLayoutItem className="d-flex gap-2">
              <Field
                wrapperStyle={{
                  width: "100%",
                  //   marginTop: 34,
                  flex: 1,
                }}
                id={"Initial"}
                name={"Initial"}
                label={"Initial"}
                placeholder="i.e. Mr."
                component={FormSelectionField}
                options={NAMEPREFIX?.map((initial: any) => {
                  return {
                    value: initial?.value,
                    label: initial?.label,
                  };
                })}
              />
              <Field
                wrapperStyle={{
                  width: "100%",
                  flex: 2,
                }}
                name="FirstName"
                label="First Name"
                placeholder="i.e.John"
                maxLength="100"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem>
              <Field
                name="LastName"
                label="Last Name"
                placeholder="i.e. Smith"
                maxLength="100"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem
            // className="d-flex gap-2"
            >
              {/* <Field
                wrapperStyle={{
                  width: "100%",
                  flex: 1,
                }}
                name="CountryCode"
                label="Code"
                astrike={true}
                placeholder="i.e. In"
                component={CoutryCodeField}
                validator={requiredValidator}
              /> */}
              <Field
                // wrapperStyle={{
                //   width: "100%",
                //   flex: 2,
                // }}
                // type="number"
                // max={16}
                name="MobileNo"
                label="Mobile No."
                type="text"
                maxLength={16}
                onKeyPress={(e: any) => {
                  const allowedChars = /^[0-9+]$/;
                  if (!allowedChars.test(e?.key)) {
                    e.preventDefault();
                  }
                }}
                placeholder="i.e. 9999999999"
                component={FormTextField}
                astrike={true}
                validator={MobileNoIntValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem>
              <Field
                name="EmailID"
                label="Email ID"
                astrike={true}
                placeholder="i.e. example@gmail.com"
                component={FormTextField}
                validator={emailValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem>
              <Field
                name={"ContactType"}
                label={"Contact Type"}
                placeholder="i.e. B2B"
                component={FormSelectionField}
                options={CONTACTTYPE?.map((initial: any) => {
                  return {
                    value: initial?.value,
                    label: initial?.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem>
              <Field
                wrapperClassName="w-100"
                id={"LeadSourceID"}
                name={"LeadSourceID"}
                label={"Lead Source"}
                placeholder="Lead Source"
                component={FormSelectionField}
                astrike={true}
                validator={requiredValidator}
                options={LeadSourceList?.map((leadsource: ILeadSource) => {
                  return {
                    value: leadsource?.ID,
                    label: leadsource?.Source,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                textAlign: "end",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={"Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 10 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateContact;
